"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getScore = void 0;
const FormQuestionType_1 = __importDefault(require("../FormQuestionType/FormQuestionType"));
const getOptionsFromConfig_1 = __importDefault(require("./getOptionsFromConfig"));
const getSelectedOptionsForAnswer_1 = __importDefault(require("./getSelectedOptionsForAnswer"));
const isAnswerableQuestion_1 = __importDefault(require("./isAnswerableQuestion"));
const isValidAnswer_1 = __importDefault(require("./isValidAnswer"));
const getScoreForQuestion = (form, node) => {
    var _a;
    const u = { max: 0, total: 0 };
    const q = form.questions[node.nodeId];
    if (q) {
        const a = form.answers[node.nodeId];
        const rule = form.rules[q.questionId];
        if ((rule === null || rule === void 0 ? void 0 : rule.scoring) && !(a === null || a === void 0 ? void 0 : a.notApplicable)) {
            const options = (0, getOptionsFromConfig_1.default)(q.type, rule);
            const isMultiSelectList = q.type === FormQuestionType_1.default.LIST &&
                rule.allowMultiSelect;
            if ((0, isAnswerableQuestion_1.default)(q)) {
                if (!options.length) {
                    u.max = 0;
                }
                else if (isMultiSelectList) {
                    u.max = options.reduce((p, c) => { var _a; return p + (isNaN(c.score) || c.score <= 0 ? 0 : (_a = c.score) !== null && _a !== void 0 ? _a : 0); }, 0);
                }
                else {
                    u.max = Math.max(...options.map(o => { var _a; return (isNaN(o.score) ? 0 : (_a = o.score) !== null && _a !== void 0 ? _a : 0); }));
                }
            }
            if ((0, isValidAnswer_1.default)(a, q, rule)) {
                const optionScores = (_a = (0, getSelectedOptionsForAnswer_1.default)(q.type, rule, a)) === null || _a === void 0 ? void 0 : _a.reduce((acc, z) => acc + (isNaN(z.score) ? 0 : z.score), 0);
                u.total = optionScores !== null && optionScores !== void 0 ? optionScores : 0;
            }
        }
    }
    return u;
};
const getScoreForQuestions = (form, nodes) => {
    var _a;
    return ((_a = nodes === null || nodes === void 0 ? void 0 : nodes.reduce((acc, curr) => {
        const a = form.answers[curr.nodeId];
        const s = (0, exports.getScore)(form, curr);
        if (!(a === null || a === void 0 ? void 0 : a.notApplicable))
            acc.max += s.max;
        acc.total += s.total;
        return acc;
    }, { max: 0, total: 0 })) !== null && _a !== void 0 ? _a : { max: 0, total: 0 });
};
const getScore = (form, questionNode, skipSubquestions) => {
    var _a, _b;
    if (!questionNode)
        questionNode = form.questionTree;
    const u = getScoreForQuestion(form, questionNode);
    if (skipSubquestions) {
        return u;
    }
    const isParentSkipped = (_a = form.answers[questionNode.questionId]) === null || _a === void 0 ? void 0 : _a.notApplicable;
    if (!isParentSkipped) {
        const subQScore = getScoreForQuestions(form, (_b = questionNode.subQuestions) === null || _b === void 0 ? void 0 : _b.filter(z => z.enabled));
        u.total += subQScore.total;
        u.max += subQScore.max;
    }
    return u;
};
exports.getScore = getScore;
exports.default = exports.getScore;
